import { getAPI } from './api-common';
import { withDefaultContextAsCurrentGeo } from 'api/api-default-context';
import { getGeosWhereUserHasProject } from 'utils/project-utils';

export const getBuildInfoRequest = () =>
  withDefaultContextAsCurrentGeo()
    .get('tieout/info')
    .then((response) => {
      return response;
    });

export const getFeatureInfoForAllGeos = async (currentUser) => {
  const uniqueGeos = getGeosWhereUserHasProject(currentUser);
  if (uniqueGeos.length) {
    return Promise.all(
      uniqueGeos.map((geoKey) =>
        getAPI(geoKey)
          .get('/tieout/info')
          .catch((e) => {
            console.log(
              'failed to fetch feature info from GEO:' + geoKey + ',error:' + e,
            );
            return null;
          }),
      ),
    ).then((responses) => {
      return responses;
    });
  }
  return Promise.resolve([]);
};

export const getFeatureFlagsForAllGeos = async (currentUser) => {
  const uniqueGeos = getGeosWhereUserHasProject(currentUser);
  if (uniqueGeos.length) {
    const apiPromises = uniqueGeos.map((geoKey) =>
      getAPI(geoKey)
        .get('/tieout/features')
        .then((response) => ({
          geoKey,
          data: response.data,
          success: true,
        }))
        .catch((e) => {
          console.log(
            'failed to fetch feature flags from GEO:' + geoKey + ',error:' + e,
          );
          return {
            geoKey,
            data: null,
            success: false,
          };
        }),
    );

    const results = await Promise.all(apiPromises);

    // arranging results by geoKey
    const responseByGeo = results.reduce((acc, result) => {
      acc[result.geoKey] = result.success ? result.data : null;
      return acc;
    }, {});

    return responseByGeo;
  }
  return {};
};
